import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UniqueEntityID } from '@digibricks/core';
import { EssayAnswerValue } from '../answer-value';
import { Answer } from './answer';
import { AudioFile, File } from '../file';
import { SubmissionScore } from '../submission-score';
import { AnswerComment } from '../answer-comment';
import { Comment } from '../comment';
export var EssayAnswer = /*#__PURE__*/function (_Answer) {
  _inherits(EssayAnswer, _Answer);

  var _super = _createSuper(EssayAnswer);

  function EssayAnswer() {
    _classCallCheck(this, EssayAnswer);

    return _super.apply(this, arguments);
  }

  _createClass(EssayAnswer, [{
    key: "value",
    get: function get() {
      return this.props.value;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      var _this$value, _this$value2, _this$value3, _this$value4;

      var isEmptyText = !((_this$value = this.value) !== null && _this$value !== void 0 && _this$value.text) || ((_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.text) === '<p></p>' || ((_this$value3 = this.value) === null || _this$value3 === void 0 ? void 0 : _this$value3.text) === '<p><br></p>';
      return isEmptyText && !((_this$value4 = this.value) !== null && _this$value4 !== void 0 && _this$value4.audioFile);
    }
  }, {
    key: "updateValue",
    value: function updateValue(newValue) {
      this.props.value = newValue;
    }
  }, {
    key: "isSkipped",
    value: function isSkipped() {
      return !this.value || this.value && (this.value.text === '' || this.value.text === '<p></p>' || this.value.text === '<p><br></p>') && this.value.files.length > 0 && !this.value.audioFile;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var dataOrError = this.createBaseProps(props);

      if (dataOrError.isFailure) {
        return Result.fail(dataOrError.error);
      }

      var baseProps = dataOrError.getValue();
      var collection = [{
        argument: props.value,
        argumentName: 'Value'
      }];
      var guardCollectionResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardCollectionResult.succeeded) {
        return Result.fail(guardCollectionResult.message);
      }

      props = _objectSpread(_objectSpread({}, baseProps), props);
      return Result.ok(new EssayAnswer(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(essayAnswer) {
      try {
        var basePropsOrError = this.createBaseProps(essayAnswer);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var answerValueProps;

        if (essayAnswer.value) {
          var _essayAnswer$value = essayAnswer.value,
              text = _essayAnswer$value.text,
              files = _essayAnswer$value.files,
              audioFile = _essayAnswer$value.audioFile;
          var mappedFiles = []; // eslint-disable-next-line no-loops/no-loops

          var _iterator = _createForOfIteratorHelper(files),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var file = _step.value;
              var fileOrError = File.fromJson(file);

              if (fileOrError.isFailure) {
                return Result.fail(fileOrError.error);
              }

              mappedFiles.push(fileOrError.getValue());
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var audioFileOrError = audioFile && AudioFile.fromJson(audioFile);

          if (audioFileOrError !== null && audioFileOrError !== void 0 && audioFileOrError.isFailure) {
            return Result.fail(audioFileOrError.error);
          }

          answerValueProps = EssayAnswerValue.create({
            text: text,
            files: mappedFiles,
            audioFile: (audioFileOrError === null || audioFileOrError === void 0 ? void 0 : audioFileOrError.getValue()) || null
          }).getValue();
        }

        var answerComment = null;

        if (essayAnswer.answerComment) {
          var comments = essayAnswer.answerComment.comments;
          var mappedComments = [];

          if (comments) {
            mappedComments = comments.map(function (comment) {
              var commentOrError = Comment.create({
                content: comment.content
              }, comment.id);

              if (commentOrError.isFailure) {
                return Result.fail(commentOrError.error);
              }

              return commentOrError.getValue();
            });
          }

          var answerCommentOrError = AnswerComment.create({
            submissionAnswerContent: essayAnswer.answerComment.submissionAnswerContent,
            comments: mappedComments
          });

          if (answerCommentOrError.isFailure) {
            return Result.fail(answerCommentOrError.error);
          }

          answerComment = answerCommentOrError.getValue();
        }

        var props = _objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          value: answerValueProps,
          score: essayAnswer !== null && essayAnswer !== void 0 && essayAnswer.score || (essayAnswer === null || essayAnswer === void 0 ? void 0 : essayAnswer.score) === 0 ? SubmissionScore.create(essayAnswer.score).getValue() : null,
          answerComment: answerComment
        });

        return Result.ok(new EssayAnswer(props, new UniqueEntityID(props.id)));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return EssayAnswer;
}(Answer);